import React from "react";
import { Accordion, Row, Col } from "react-bootstrap";
import "../AccordianPanel/style.scss";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import PropTypes from "prop-types";

export const DetailRow = ({ label = '', value = "" }) => (
  <tr>
    <td>{label}</td>
    <td>: {value}</td>
  </tr>
);
DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
};

const AccordionSection = ({ eventKey = 0, header, details = [] }) => (
  <div className="my-2">
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>{header}</Accordion.Header>
      <Accordion.Body>
        <div className="Accordian">
          <Row>
            {details.map((section, index) => (
              <Col className="rowsper" key={index} md={6}  >
                <div className="para headerAcc1">
                  <h5>{section.heading}</h5>
                  <span className="tdcols1">
                    {section.details.map((detail, detailIndex) => (
                      <DetailRow key={detailIndex} label={detail.label} value={detail.value} />
                    ))}
                  </span>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  </div>
);
export default AccordionSection;
AccordionSection.propTypes = {
  eventKey: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      details: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
        })
      ),
    })
  ).isRequired,
};

export const MultipleOpenAccordian = ({ eventKey, header, body, openItems, handleToggle = () => { } }) => (
  <Accordion defaultActiveKey="">
    <div className="accordion-item">
      <div
        className="accordion-header"
        onClick={() => handleToggle(eventKey)}
        role="button"
        aria-expanded={!!openItems[eventKey]}
      >
        <h5>{header}</h5>
        <div className="accordion-arrow">
          {openItems[eventKey] ? (
            <IoIosArrowDropup size={20} color="grey" />
          ) : (
            <IoIosArrowDropdown size={20} color="grey" />
          )}
        </div>
      </div>
      {openItems[eventKey] && (
        <div className="accordion-body">{body}</div>
      )}
    </div>
  </Accordion>
);
MultipleOpenAccordian.propTypes = {
  eventKey: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  openItems: PropTypes.objectOf(PropTypes.bool).isRequired,
  handleToggle: PropTypes.func.isRequired,
};


